import React, { useState, useEffect } from 'react';
import Webcam from 'react-webcam';

export default function CameraComponent({capturedImage}) {

    const videoConstraints = {
        facingMode: "environment",
        aspectRatio: 1/1,
        focusMode: 'auto',
        focusDistance: 10
    };
  
    return (
        <div>
            {capturedImage === '' && <Webcam
                audio={false}
                screenshotQuality={1}
                playsInline
                videoConstraints={videoConstraints}
            />}
        </div>
    );
}
  